module.exports = __webpack_public_path__ + "static/media/Topic_Icons2_ResourcesBox.61759926.png";